// eslint-disable-next-line no-shadow
export enum LISTVIEW_COOKIE_TYPE {
  GALLERY = "G",
  LIST = "L",
}

export const PRODUCT_VIEW_MODE_GALLERY = "productViewModeGallery";
